import styled from "styled-components"
import Typography, { FontFamilySmartScreen } from "../shared/typography.styles"
import Breakpoints from "../shared/breakpoints"
import Img from "gatsby-image"

/* LIGHTBOX */

/* LIGHTBOX BIO CARDS */

export const BioCardWrapper = styled.div`
  flex: 1 1 100%;
  display: flex;
  flex-direction: row;
  min-height: 250px;
  max-height: 80vh;

  background-color: #fff;

  box-shadow: 0px 2px 15px rgba(0, 0, 0, 0.25);
`

export const BioCardImg = styled(Img)`
  min-width: clamp(250px, 33%, 400px);

  background-color: #2e2e2ea0;
  object-fit: cover;
`

export const BioCardContentContainer = styled.div`
  flex: 1 1 65%;
  overflow-y: auto;
  overflow-x: hidden;

  padding: 48px;

  & > h3 {
    ${Typography.desktopTextStyles.HeadingThreeRegular}
  }

  & > h4 {
    ${Typography.desktopTextStyles.HeadingSixRegular}
    color: var(--burnt-orange);
    margin-top: 12px;
  }

  & > p {
    ${Typography.desktopTextStyles.BodyText16}
    margin-top: 24px;
  }
`

/* SECTION ELEMENTS */

export const SectionContainer = styled.div`
  background-color: var(--slate);
  padding: 48px 0;

  @media (min-width: ${Breakpoints.lg}) {
    padding: 96px 0;
  }
`

export const Title = styled.h2`
  ${Typography.mobileTextStyles.MobileHeadingTwoSemiBold}
  color: var(--white);
  grid-column: 2 / -2;
  text-align: center;

  @media (min-width: ${Breakpoints.md}) {
    ${Typography.tabletTextStyles.TabletHeadingTwoSemiBold}
    padding-bottom: 16px;
    grid-column: 3 / -3;
    border-bottom: 1px solid #f2f2f240;
  }
  @media (min-width: ${Breakpoints.lg}) {
    ${Typography.desktopTextStyles.HeadingTwoSemiBold}
    padding-bottom: 32px;
  }
`

export const ProfileCardContainerWrapper = styled.div`
  grid-column: 1 / -1;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;

  @media (min-width: ${Breakpoints.lg}) {
    grid-column: 2 / -2;
  }
`

export const ProfileCardSliderWrapper = styled.div`
  width: 100%;
  grid-column: 1 / -1;
  & .slick-prev {
    transform: translate3d(20px, 0, 0);
  }
  & .slick-next {
    transform: translate3d(-20px, 0, 0);
  }
`

export const ProfileCardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  color: var(--dark-mode-body-grey);
  text-align: center;
  outline: none;

  @media (min-width: ${Breakpoints.md}) {
    flex-basis: 0 0 calc(33% - 48px);
    margin: 48px 24px 0 24px;
    width: 20vw;
    max-width: 256px;
  }

  @media (min-width: ${Breakpoints.lg}) {
    cursor: pointer;
  }
`

export const ProfileCardImageWrapper = styled.div`
  & img {
    object-fit: contain;
    max-height: 300px;
    margin: 48px auto;
  }

  @media (min-width: ${Breakpoints.md}) {
    max-height: 300px;
    & img {
      margin: 0;
      max-width: 100%;
      width: 100%;
      height: 23vw;
      max-height: 300px;
      object-fit: cover;
    }
  }

  width: 100%;

  .react-card-flipper {
    width: 100% !important;
  }
`
export const ProfileCardName = styled.h3`
  margin-top: 24px;
  ${Typography.tabletTextStyles.TabletHeadingFourRegular}
  @media (min-width: ${Breakpoints.md}) {
    ${Typography.tabletTextStyles.TabletHeadingFourRegular}
  }
  @media (min-width: ${Breakpoints.lg}) {
    ${Typography.desktopTextStyles.HeadingFourBold}
  }
`

export const ProfileCardTitle = styled.p`
  ${Typography.desktopTextStyles.FooterHeadingTwo}
  margin-top: 12px;

  font-weight: 300;
  margin-bottom: 24px;
  @media (min-width: ${Breakpoints.md}) {
    font-size: 12px;
  }
  @media (min-width: ${Breakpoints.lg}) {
    font-size: 14px;
  }
`

export const ProfileCardTabletButton = styled.button`
  padding: 16px 32px;
  background-color: rgba(0, 0, 0, 0);
  ${FontFamilySmartScreen}
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  border: 1px solid var(--white);
  color: var(--white);
  margin-top: auto;
  justify-self: flex-end;
  cursor: pointer;
  white-space: nowrap;
`
